'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CookieSetError = function (_Error) {
  _inherits(CookieSetError, _Error);

  function CookieSetError(message) {
    _classCallCheck(this, CookieSetError);

    var _this = _possibleConstructorReturn(this, (CookieSetError.__proto__ || Object.getPrototypeOf(CookieSetError)).call(this, message || 'Could not set cookie'));

    _this.name = 'CookieSetError';
    return _this;
  }

  return CookieSetError;
}(Error);

exports.default = CookieSetError;
module.exports = exports['default'];